






















































/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Prop, Vue } from 'vue-property-decorator';
import ErrorResponseMixin from '@mixin/errorResponse';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    data() {
        return {
            password: '',
            repeatpassword: '',
            email: this.$route.query.email,
            token: this.$route.query.token,
            terms: false,
        };
    },

    mixins: [
        ErrorResponseMixin,
    ],

    methods: {
        submit() {
            this.$validator.validate().then(valid => {
                if (!valid) return;
                this.isValid();
            });
        },

        isValid() {
            if (this.password !== this.repeatpassword) {
                this.errorData = { message: 'De wachtwoorden komen niet overeen' }
            } else if (this.showTerms && !this.terms) {
                this.errorData = { message: 'Akkoord met de termen is vereist' }
            } else {
                this.$store.dispatch('user/reset', {
                    email: this.email,
                    token: this.token,
                    password: this.password,
                    password_confirmation: this.repeatpassword,
                }).then((response) => {
                    if (response instanceof Error) {
                        this.errorData = { message: response.response.data.message }
                        return;
                    }

                    this.$router.push({
                        path: '/login',
                    })
                });
            }
        }
    },
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class ResetForm extends Vue {
    @Prop(Boolean) showTerms: boolean;
}

